import { uuidPattern } from "../../lib/raft_generic_helper";
import { useDrupalSettings } from "../../composables/useDrupalSettings";

const { config } = useDrupalSettings();

const RaftMessaging = () =>
  import("../../components/raft_messaging/RaftMessaging.vue");
const MessageList = () =>
  import("../../components/raft_messaging/MessageList.vue");
const MessageView = () =>
  import("../../components/raft_messaging/MessageView.vue");
const MessageTemplateForm = () =>
  import("../../components/raft_messaging/MessageTemplateForm.vue");
const MessageTemplateListing = () =>
  import("../../components/raft_messaging/MessageTemplateListing.vue");
const QueueConfigForm = () =>
  import("../../components/raft_messaging/QueueConfigForm.vue");
const QueueConfigListing = () =>
  import("../../components/raft_messaging/QueueConfigListing.vue");

const routes = [
  {
    path: "/raft/message-center/configuration",
    name: "raft_messaging_template_config",
    component: MessageTemplateListing,
  },
  {
    path: "/raft/message-center/configuration/templates",
    name: "raft_messaging_template_list",
    component: MessageTemplateListing,
  },
  {
    path: "/raft/message-center/configuration/templates/create",
    name: "raft_messaging_template_create",
    component: MessageTemplateForm,
  },
  {
    path:
      "/raft/message-center/configuration/templates/:templateUuid(" +
      uuidPattern +
      ")/view",
    name: "raft_messaging_template_view",
    component: null,
    props: true,
  },
  {
    path:
      "/raft/message-center/configuration/templates/:uuid(" +
      uuidPattern +
      ")/edit",
    name: "raft_messaging_template_edit",
    component: MessageTemplateForm,
    props: true,
  },
  {
    path: "/raft/message-center/configuration/queue/create",
    name: "raft_messaging_queue_config_create",
    component: QueueConfigForm,
  },
  {
    path: "/raft/message-center/configuration/queues",
    name: "raft_messaging_queue_config_listing",
    component: QueueConfigListing,
  },
  {
    path:
      "/raft/message-center/configuration/queue/:uuid(" +
      uuidPattern +
      ")/edit",
    name: "raft_messaging_queue_config_edit",
    component: QueueConfigForm,
    props: true,
  },
  {
    path: "/raft/message-center/sent-messages",
    name: "raft_messaging_system_outbox",
    component: MessageList,
  },
  {
    path: "/raft/message-center/message/:messageUuid(" + uuidPattern + ")/view",
    name: "raft_messaging_message_view",
    component: MessageView,
    props: true,
  },
  {
    path: "/user/:userId/message-center/inbox",
    alias: "/user/:userId/message-center",
    name: "user_message_inbox",
    component: MessageList,
    props: (route) => ({ userId: route.params.userId, inbox: true }),
  },
  {
    path: "/user/:userId/message-center/sent-messages",
    name: "user_message_outbox",
    component: MessageList,
    props: true,
  },
  {
    path: "/node/:groupNid([0-9]+)/view/correspondence",
    name: "group_correspondence",
    component: MessageList,
    props: true,
  },
  {
    path: "/user/:userId/correspondence",
    name: "user_correspondence",
    component: MessageList,
    props: true,
  },
  {
    path: "/raft/my_account/messaging/",
    alias: "/raft/my_account/messaging/inbox",
    name: "user_messaging",
    component: MessageList,
    props: { userId: config.currentUser, inbox: true },
  },
  {
    path: "/raft/my_account/messaging/outbox",
    name: "user_messaging",
    component: MessageList,
    props: { userId: config.currentUser },
  },
];

const globalComponents = { RaftMessaging };

export {
  routes as messagingRoutes,
  globalComponents as messagingGlobalComponents,
};
